import { InputAdornment, TextField } from '@material-ui/core';
import React from 'react';
import CurrencyInput, { cleanValue } from 'react-currency-input-field';

const currencyProps = {
  prefix: "R$ ",
  decimalSeparator: ",",
  groupSeparator: ".",
  decimalLimits: 2
}

export const cleanPrice = (price) => {
  return !Number.isNaN(+price) ? price : Number(cleanValue({ value: price, ...currencyProps })?.replace(',', '.'));
}

function CustomCurrencyInput(props) {
  const { inputRef, onChange, ...other } = props;

  return (
    <CurrencyInput
      {...other}
      allowNegativeValue={false}
      onValueChange={(value, name, values) => {
        onChange({
          target: {
            name: props.name,
            value,
          },
        });
      }}
      disableAbbreviations
      decimalScale={2}
      {...currencyProps}
    />
  );
}

export default function PriceField({ label = "Valor", price, onChangePrice, error, helperText }) {
  return (
    <TextField
      label={label}
      value={price}
      onChange={e => onChangePrice(e.target.value)}
      InputProps={{
        inputComponent: CustomCurrencyInput,
      }}
      InputLabelProps={{
        shrink: true
      }}
      error={error}
      helperText={helperText}
    />
  );
}